export default "__VITE_ASSET__DiPfMpmq__"